import { PureComponent } from "react";

import yup from "utilities/form/yup";

import { Currency } from "commonComponents/financial/Currency/Currency";
import { CurrencyDisplay } from "commonComponents/financial/CurrencyDisplay/CurrencyDisplay";
import { type IFooterCellProps } from "commonComponents/utilities/Grid/common/BTGridFooterCell/BTGridFooterCell";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
    type IGridFilterCellRenderProps,
} from "commonComponents/utilities/Grid/GridContainer.types";

const noop = () => {};

export interface INumberResponse {
    value: number | undefined;
    scale: number;
}

interface ICurrencyCellProps extends IGridCellRenderProps<INumberResponse | undefined> {
    shouldUseAccountingMode: boolean;
}

interface ICurrencyFooterCellProps extends IFooterCellProps {
    shouldUseAccountingMode: boolean;
}

export class CurrencyFilterCell extends PureComponent<
    IGridFilterCellRenderProps<INumberResponse | undefined>
> {
    private handleChange = (field: string, value: number | undefined) => {
        const { cellValue, onChange } = this.props;
        onChange(field, {
            precision: 0,
            ...cellValue,
            value,
        });
    };
    render() {
        const { cellValue, field } = this.props;
        return (
            <Currency<undefined>
                id={field.full}
                data-testid={field.full}
                value={cellValue ? cellValue.value : undefined}
                onChange={this.handleChange}
                onBlur={noop}
                decimalScale={cellValue ? cellValue.scale : undefined}
            />
        );
    }
}

export class CurrencyCell extends PureComponent<ICurrencyCellProps> {
    render() {
        const { cellValue, shouldUseAccountingMode } = this.props;
        return cellValue && cellValue.value !== undefined && cellValue.value !== null ? (
            <CurrencyDisplay
                value={cellValue.value}
                decimalScale={cellValue.scale}
                accountingMode={shouldUseAccountingMode}
            />
        ) : null;
    }
}

export class CurrencyFooterCell extends PureComponent<ICurrencyFooterCellProps> {
    render() {
        const { value, shouldUseAccountingMode } = this.props;
        if (!value || value.value === undefined || value.value === null) {
            return null;
        }
        return (
            <CurrencyDisplay
                value={value.value}
                decimalScale={value.precision}
                accountingMode={shouldUseAccountingMode}
            />
        );
    }
}

export const columnCurrency: IClientGridColumn<INumberResponse | undefined> = {
    validationSchema: yup.object<INumberResponse>({
        value: yup.number(),
        scale: yup.number(),
    }),
    columnType: GridColumnType.currency,
    FilterCell: CurrencyFilterCell,
    Cell: (props: IGridCellRenderProps<INumberResponse | undefined>) => (
        <CurrencyCell {...props} shouldUseAccountingMode={false} />
    ),
    FooterCell: (props) => <CurrencyFooterCell {...props} shouldUseAccountingMode={false} />,
};

export const columnCurrencyAccounting: IClientGridColumn<INumberResponse | undefined> = {
    validationSchema: yup.object<INumberResponse>({
        value: yup.number(),
        scale: yup.number(),
    }),
    columnType: GridColumnType.currencyAccounting,
    FilterCell: CurrencyFilterCell,
    Cell: (props: IGridCellRenderProps<INumberResponse | undefined>) => (
        <CurrencyCell {...props} shouldUseAccountingMode={true} />
    ),
    FooterCell: (props) => <CurrencyFooterCell {...props} shouldUseAccountingMode={true} />,
};
